import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)

//引入iconfont
import '@/assets/iconfont/iconfont.css'

Vue.config.productionTip = false

//引入全局路由
import navigation from './assets/js/navigation.js'
Vue.prototype.navigation = navigation

//引入图表插件
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入公共方法库
import qaUtil from './assets/js/qaUtil.js'
Vue.prototype.qaUtil = qaUtil

import axios from 'axios'
axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://sltestapi.qinangit.com:8080'//线上测试服务器
// axios.defaults.baseURL = 'http://192.168.10.93:8651'//线上测试服务器
// axios.defaults.baseURL = 'http://localhost:8651'
// axios.defaults.baseURL = 'http://192.168.10.56:8651'
// axios.defaults.baseURL = 'http://192.168.1.6:8651'
// axios.defaults.baseURL = 'http://slapi.qinangit.com'//线上正式服务器
axios.defaults.baseURL = 'https://pwapi.qhdqxrhc.com'//求仙

axios.interceptors.request.use(config => {
    // config.headers.userToken = window.sessionStorage.getItem('userToken');
    // config.headers.userName = window.sessionStorage.getItem('userName');
    return config;
})

Vue.prototype.$http = axios


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
